export default __webpack_public_path__ + "static/media/Mark-3-HUD-Label (Warning).b055ee8f.jpg";